import React from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import TextField from '@mui/material/TextField';
import FormGroup from '@mui/material/FormGroup';
import { useController, useFormContext } from 'react-hook-form';
import styles from './FormTimeInput.module.scss';

export default function FormTimeInput(props) {
  const { label, defaultValue, disabled } = props;
  const { control } = useFormContext();
  const useControllerProps = {
    ...props,
    control,
    defaultValue: defaultValue || '',
  };

  const {
    field: { onChange, onBlur, name, value, ref },
    fieldState: { error },
  } = useController(useControllerProps);

  return (
    <FormGroup className={styles.timeInput}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <TimePicker
          disabled={disabled}
          ampm={false}
          disableOpenPicker
          id={name}
          name={name}
          value={value}
          label={label}
          disableIgnoringDatePartForTimeValidation
          format="HH:mm"
          onChange={onChange}
          onBlur={onBlur}
          inputRef={ref}
          dateAdapter
          slotProps={{
            textField: {
              fullWidth: true,
              variant: 'outlined',
              error,
            },
          }}
        />
      </LocalizationProvider>
    </FormGroup>
  );
}
